import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { RoutingUtils } from './utils';

export const ROUTES_APP: Routes = [
  {
    path: RoutingUtils.Routes.FAILED,
    loadChildren: () => import('./feature/upload-failed/upload-failed.module').then(m => m.UploadFailedModule)
  },
  {
    path: RoutingUtils.Routes.SESSION,
    loadChildren: () => import('./feature/session-expired/session-expired.module').then(m => m.SessionExpiredModule),
  },
  {
    path: RoutingUtils.Routes.INCOMPATIBLE,
    loadChildren: () => import('./feature/incompatible-browser/incompatible-browser.module').then(m => m.IncompatibleBrowserModule),
  },
  {
    canActivate: [AuthGuard],
    path: RoutingUtils.Routes.AUTHENTICATION,
    loadChildren: () => import('./feature/login/login.module').then(m => m.LoginModule),
  }

];
